import { render, staticRenderFns } from "./layoutBlank.vue?vue&type=template&id=180db6ac&"
import script from "./layoutBlank.vue?vue&type=script&lang=js&"
export * from "./layoutBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180db6ac')) {
      api.createRecord('180db6ac', component.options)
    } else {
      api.reload('180db6ac', component.options)
    }
    module.hot.accept("./layoutBlank.vue?vue&type=template&id=180db6ac&", function () {
      api.rerender('180db6ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/layouts/layoutBlank.vue"
export default component.exports